<template>
  <div class=" ">
    <div class="bg-white px-8 pt-5 border-b-[1px] page-head">
      <app-header
        :name="pmLocalID ? pmLocalTitle : $t('pmLocals.editPmLocal')"
        :clickEvent="handleGoToBack"
        :show-arrow-back="true"
      >
      </app-header>
      <div class="pt-5 pb-2">
        <button
          v-for="(tab, index) in filteredTabs()"
          :key="index"
          :class="['tab-button', { active: currentTab === tab.id }]"
          @click="handleProceed(tab.id)"
        >
          <span class="tab-tooltip">
            {{ $t(getTranslatedStringKey(tab.name)) }}
          </span>
        </button>
      </div>
    </div>

    <div class="px-8">
        <component
          :is="currentTab"
          v-bind="isCurrentTab"
          class="pt-10"
        ></component>
      
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

import ProjectOverview from "@/components/dashboard/projects/pm-local/projectOverview/ProjectOverview.vue";
import ProjectOverviewExpense from "@/components/dashboard/projects/pm-local/expense/ProjectOverviewExpense.vue";
import Cheques from "@/components/dashboard/projects/pm-local/cheques/Cheques.vue";
import AddNewCheque from "@/components/dashboard/projects/pm-local/cheques/AddNewCheque.vue";
import BankCah from "@/components/dashboard/projects/pm-local/bank-cash/BankCash.vue";
import Currency from "@/components/dashboard/projects/pm-local/currency-exchange/CurrencyExchange.vue";
import RequestedFunds from "@/components/dashboard/projects/pm-local/RequestedFunds.vue";
import RequestNewFund from "@/components/dashboard/projects/pm-local/RequestNewFund.vue";
import Instructions from "@/components/dashboard/projects/pm-local/Instructions.vue";

import { mapState } from "vuex";
import { getTransString } from "@/services/helpers";
export default defineComponent({
  name: "EditPmLocal",
  components: {
    ProjectOverview,
    ProjectOverviewExpense,
    Cheques,
    AddNewCheque,
    BankCah,
    Currency,
    RequestedFunds,
    // ProjectFunds,
    RequestNewFund,
    Instructions
  },
  data() {
    return {
      currentTab: "Personal",
      tabList: [
        "Project Overview",
        "Expenses",
        "Cheques",
        "Add / Update Cheque",
        "Bank/Cash",
        "Currency Exchange",
        // "Project Funds",
        "Requested Funds",
        "Request New Fund",
      ],
      tabs: [
        "ProjectOverview",
        "ProjectOverviewExpense",
        "Cheques",
        "AddNewCheque",
        "BankCah",
        "Currency",
        // "ProjectFunds",
        "RequestedFunds",
        "RequestNewFund",
        "Instructions"
      ],
      newTabList: [
        {
          id: "ProjectOverview",
          name: "Project Overview",
        },
        {
          id: "ProjectOverviewExpense",
          name: "Expenses",
        },
        {
          id: "Cheques",
          name: "Cheques",
        },
        {
          id: "AddNewCheque",
          name: "Add / Update Cheque",
        },
        {
          id: "BankCah",
          name: "Bank/Cash",
        },
        {
          id: "Currency",
          name: "Currency Exchange",
        },
        // {
        //   id: "ProjectFunds",
        //   name: "Project Funds",
        // },
        {
          id: "RequestedFunds",
          name: "Requested Funds",
        },

        {
          id: "RequestNewFund",
          name: "Request New Fund",
        },
        {
          id: "Instructions",
          name: "Instructions",
        }
      ],
     
    };
  },

  computed: {
    isEditButton() {
      return this.$store.getters["hrResources/isEditButton"];
    },
    pmLocalID() {
      return this.$store.getters["pmLocalModules/isPmLocalID"];
    },
    isCurrentTab() {
      return this.$store.getters["commonResources/isCurrentTab"];
    },
    pmLocalTitle() {
      return this.$store.getters["pmLocalModules/isPmLOcalTitle"];
    },
    isCheckAcceptance() {
      return this.$store.getters["pmLocalModules/isCheckAcceptance"];
    },
    isAddCheque() {
      return this.$store.getters["chequeModules/isAddCheque"];
    },
    isAddExpense() {
      return this.$store.getters["projectOverview/isAddExpense"];
    },
    getShowRequestNewFund() {
      return this.$store.getters["pmLocalModules/getShowRequestNewFund"];
    },
    isEditCheque() {
      return this.$store.getters["chequeModules/isEditCheque"];
    },

    ...mapState(["translation"]),
  },

  methods: {
    showEditButton() {
      this.$store.commit("hrResources/SET_SHOW_EDIT_BUTTON_TO_STATE", true);
    },
    getSingleOffice(id) {
      if (this.pmLocalID) {
        const payload = {
          load_page: true,
          pmLocalID: id,
        };
        this.$store.dispatch("pmLocalModules/getSingleOffice", payload);
      }
    },
    getTranslatedStringKey(field) {
      return getTransString(field);
    },
    handleBeforeUnload(event) {
      if (this.checkChangeStatus()) {
        // Customize the confirmation message
        const confirmationMessage =
          "You have unsaved changes. Are you sure you want to leave this page?";

        // Display the confirmation dialog
        event.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    },
    checkChangeStatus() {
      return Object.values(this.pmLocalUpdate)?.some((elt) => elt === true);
    },
    handleProceed(id) {
      const index = this.tabs.indexOf(id);
      this.$store.commit("commonResources/SET_CURRENT_TAB_TO_STATE", index);
    },
    handleGoToBack() {
      this.$router.go(-1);
    },
    filteredTabs() {
      let hasCheckAcceptance = this.isCheckAcceptance;
      let hasAddCheque = this.isAddCheque;
      let hasAddExpense = this.isAddExpense;
      let hasRequestNewFund = this.getShowRequestNewFund;

      if (
        hasCheckAcceptance &&
        hasAddCheque &&
        hasAddExpense &&
        hasRequestNewFund
      ) {
        return this.newTabList;
      } else if (hasCheckAcceptance && hasAddCheque && hasAddExpense) {
        return this.newTabList.filter((tab) => tab.id !== "RequestNewFund");
      } else if (hasCheckAcceptance && hasAddExpense && hasRequestNewFund) {
        return this.newTabList.filter((tab) => tab.id !== "AddNewCheque");
      } else if (hasCheckAcceptance && hasAddExpense) {
        return this.newTabList.filter(
          (tab) => tab.id !== "AddNewCheque" && tab.id !== "RequestNewFund"
        );
      } else if (hasCheckAcceptance && hasAddCheque && this.isEditCheque) {
        return this.newTabList.filter(
          (tab) => tab.id !== "ProjectOverviewExpense"
        );
      } else if (hasCheckAcceptance && hasAddCheque) {
        return this.newTabList.filter(
          (tab) => tab.id !== "ProjectOverviewExpense"
        );
      } else if (hasAddExpense && hasRequestNewFund) {
        return this.newTabList.filter((tab) => tab.id !== "AddNewCheque");
      } else if (hasCheckAcceptance) {
        return this.newTabList.filter(
          (tab) =>
            tab.id !== "AddNewCheque" &&
            tab.id !== "ProjectOverviewExpense" &&
            tab.id !== "RequestNewFund"
        );
      } else if (hasAddExpense) {
        return this.newTabList.filter(
          (tab) =>
            tab.id !== "Cheques" &&
            tab.id !== "AddNewCheque" &&
            tab.id !== "RequestNewFund"
        );
      } else if (hasRequestNewFund) {
        return this.newTabList.filter(
          (tab) =>
            tab.id !== "Cheques" &&
            tab.id !== "AddNewCheque" &&
            tab.id !== "ProjectOverviewExpense"
        );
      } else {
        return this.newTabList.filter(
          (tab) =>
            tab.id !== "Cheques" &&
            tab.id !== "AddNewCheque" &&
            tab.id !== "ProjectOverviewExpense" &&
            tab.id !== "RequestNewFund"
        );
      }
    },
  },

  updated() {
    this.currentTab = this.tabs[this.isCurrentTab];
  },
  created() {
    this.currentTab = this.tabs[this.isCurrentTab];
  },
});
</script>


